import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FeaturesSection } from './components/FeaturesSection';
import { AppPreviewSection } from './components/AppPreviewSection';
import { WhyAscensionSection } from './components/WhyAscensionSection';
import { EarlyAccessSection } from './components/EarlyAccessSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-ascension-black text-white font-sans selection:bg-ascension-green/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HowItWorksSection data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <AppPreviewSection data-id="element-6" />
        <WhyAscensionSection data-id="element-7" />
        <EarlyAccessSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}